/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TabService } from '../../../core/services/tab.service';
import { QueryViewService } from '../../shared/services/query-view.service';
import { LmsEventDetails } from './../../../core/model/lms-event-details.model';
import { LocoDetail } from './../../../core/model/loco-detail.model';
import { Tab } from './../../../core/model/tab.model';
import { AppUtilityService } from './../../../core/services/app-utility.service';
import { ConfigService } from './../../../core/services/config.service';
import { LmsLoaderService } from './../../../core/services/lms-loader.service';
import { MessageHandlerService } from './../../../core/services/message-handler.service';



/**
 * @export
 * @class QueryViewHeaderComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'lms-query-view-header',
  templateUrl: './query-view-header.component.html',
  styleUrls: ['./query-view-header.component.scss']
})
export class QueryViewHeaderComponent implements OnInit {

  @Input() lastRefreshTime: string;
  @Input() locoStatusArr: Array<LocoDetail>;
  @Input() tab: Tab;
  @Input() tabs: Tab[];
  filteredLocoStatusArr: Array<LocoDetail>;
  displayLastRefershTime: string;
  @Output() refreshBtnEvent = new EventEmitter();
  configData: any;
  editMode: any;
  /**
   * Creates an instance of LocoStatusHeaderComponent.
   * @memberOf LocoStatusHeaderComponent
   */
  constructor(private queryViewService: QueryViewService,
    private lmsLoaderService: LmsLoaderService,
    private appUtilityService: AppUtilityService,
    private messageHandlerService: MessageHandlerService,
    private configService: ConfigService,
    private tabService: TabService) {
    this.configData = this.configService.getConfigData();
  }

  lmsEventHandler(lmsEventDetails: LmsEventDetails) {
    this.tabService.notifyChange(lmsEventDetails);
  }

  /**
   * Initialize the state of lifecycle hook.
   * @memberOf LocoStatusHeaderComponent
   */
  ngOnInit() {
  }

  /**
   * Invoked for refresh loco status screen.
   * @memberOf LocoStatusHeaderComponent
   */
  refreshLocoStatus() {
    this.refreshBtnEvent.emit();
  }

}
